import { render, staticRenderFns } from "./artefacts.vue?vue&type=template&id=2cda6dbd&scoped=true&"
import script from "./artefacts.vue?vue&type=script&lang=ts&"
export * from "./artefacts.vue?vue&type=script&lang=ts&"
import style0 from "./artefacts.vue?vue&type=style&index=0&id=2cda6dbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cda6dbd",
  null
  
)

export default component.exports